// index.css is handled by the mini-css-extract-plugin.
// Note importsNotUsedAsValues in tsconfig.settings and discussion
// in this issue: https://github.com/microsoft/TypeScript/issues/9191
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import index from '../assets/css/index.css';

const App = import('./App');
export default App;
